import * as languageActionCreators from './languageActionCreators';

export const setLanguage = (languageCode) => (dispatch, getState) => {
  const myId = getState().auth.get('id');
  dispatch(languageActionCreators.updateLanguage(myId, languageCode));
};
